import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import styles from '../igrow.module.css';

type SectionCardProps = {
  title: string;
  tone: 'lavender' | 'pink';
  icon: LucideIcon;
  children: ReactNode;
};

export default function SectionCard({ title, tone, icon: Icon, children }: SectionCardProps) {
  const legendTone = tone === 'pink' ? styles.legendPink : styles.legendLavender;
  const badgeTone = tone === 'pink' ? styles.badgePink : styles.badgePurple;

  return (
    <fieldset className={styles.section}>
      <legend className={`${styles.legend} ${legendTone}`}>
        <span className={`${styles.badge} ${badgeTone}`}>
          <Icon size={18} strokeWidth={2.25} aria-hidden="true" />
        </span>
        <span>{title}</span>
      </legend>
      <div className={styles.sectionBody}>{children}</div>
    </fieldset>
  );
}
